import React from 'react';
import { observer } from 'mobx-react';
import Modal from 'simple-react-modal';

import { ANCHOR_VIEW } from '../../../constants/apiUrls/apiUrls';
import callApi from '../../../utils/callApi';
import { getCookie } from '../../../utils/helpers';
import { PROMO_CODES } from '../../../constants/promoCodes';
import './ContextualJoinOverlay.css';
import StarsIcon from '@material-ui/icons/Stars';
import defaultImage from '../../../assets/modal/FanZone-Generic.jpg';
import FanclubPackageStore from '../../../store/FanclubPackageStore';

@observer
class ContextualJoinOverlay extends React.Component {
  state = {
    joinOverlayImage: null,
    anchorFirstName: ''
  }

  componentDidMount() {
    const { anchorId } = this.props;
    this.getAnchorJoinOverlayImage();
    FanclubPackageStore.getFanclubSubscriptionPackage(anchorId);
  }

  getAnchorJoinOverlayImage = () => {
    const { anchorId } = this.props;
    const url = ANCHOR_VIEW.replace('{id}', encodeURIComponent(anchorId));

    callApi(url, 'get', {}, {}, {}, true, true)
      .then(res => {
        if (res.status === 200 && res.data) {
          const { joinOverlay, name } = res.data;
          const anchorFirstName = name && name.split(' ')[0];
          this.props.setNakedNewsLivePromoUrl(res.data.promoClip, res.data.fanzonePromopic);
          this.setState({ joinOverlayImage: joinOverlay, anchorFirstName });
        }
      })
      .catch(error => {
        console.error(error);
      });
  }

  renderFeatures = () => {
    const { anchorFirstName } = this.state;
    const { user } = this.props;
    const groupShowFeatureAvailable = user ? user.features.includes('TEMPTED_PRIVATE_SHOW') : false;
    
    const features = [
      {id: 1, item: groupShowFeatureAvailable ? 'Access to Live Streams and Party Shows' : 'Access to Live Streams'},
      {id: 2, item: groupShowFeatureAvailable ? 'Ability to chat during Live Streams and Party Shows' : 'Ability to chat during streams'},
      {id: 3, item: 'Access to new and exclusive content like Galleries, Videos etc.'},
      {id: 4, item: `Send private messages to ${anchorFirstName}`},
    ];

    return features.map(feature => {
      return(
        <div key={feature.id} className='contextual-join-overlay__feature'>
          <span className='contextual-join-overlay__icon'>
            <StarsIcon />
          </span>
          <span>{feature.item}</span>
        </div>
      );
    })
  }

  subscribe = () => {
    const { history, anchorId, anchorShortUrl } = this.props;
    
    if(anchorShortUrl) {
      history.push(`/account/purchase?_anchor=${anchorId}&_shortUrl=${anchorShortUrl}`);
    } else {
      history.push(`/account/purchase?_anchor=${anchorId}`);
    }
  }

  render() {
    const { 
      closeContextualOverlay, 
      showOverlay,
      anchorPortalCampaign: { anchorPortal }
    } = this.props;
    const { fanclubPackagePrice } = FanclubPackageStore;

    const {
      anchorFirstName,
      joinOverlayImage
    } = this.state;

    const atc = getCookie('_atc');
    const fanDiscountActive = (atc === PROMO_CODES.CAM4_ANCHOR_SOURCE || atc === PROMO_CODES.PROMO_ANCHOR_SOURCE) && anchorPortal;
    
    return (
      <Modal
        containerClassName="contextual-join-overlay"
        show={showOverlay}
        onClose={() => closeContextualOverlay(false)}
      >
        <div
          className="contextual-join-overlay__image"
          style={{
            background: `url(${joinOverlayImage || defaultImage}) 
                           no-repeat top center / cover`
          }}
        ></div>
        <div className="contextual-join-overlay__info">
          <h2>Get access to the Fan Zone!</h2>
          <p>
            For only{" "}
            <strong>
              <span className={fanDiscountActive ? "discount" : null}>{fanclubPackagePrice}</span>{" "}
              {fanDiscountActive && '$4.95 '}
              {fanDiscountActive ? 'first month' : 'per month'}
            </strong>{" "}
            you can support {anchorFirstName} directly and enjoy awesome perks
            like:
          </p>
          <div className="contextual-join-overlay__features">
            {this.renderFeatures()}
          </div>
          <span
            onClick={this.subscribe}
            className="contextual-join-overlay__join"
          >
            Join Now
          </span>
        </div>
      </Modal>
    );
  }
}

export default ContextualJoinOverlay;
